import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MemoryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"memory"}/>
}
